import React, { useEffect } from 'react';
import Tab from '../../Components/Tab/Tab';
import './Index.scss';
import { alertRef } from '../../App';
import { Outlet, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const routeList = {
    '/customer/customer-list': '고객 목록',
    '/customer/customer-memo' : '메모 미입력 목록',
}

const Customer = (props) => {
    const [ name, setName ] = React.useState('customer-list')
    const route = useSelector((state) => state.user.route)
    const navigate = useNavigate();
    
    const tabRoute = [
        { route : 'customer-list', header : '고객 목록' },
        { route : 'customer-memo', header : '메모 미입력 목록' },
    ]

    return (
        <div className='wrapper'>
            <div className='header-row' style={{ marginLeft : 20 }}>
                <p className='header-text'>고객 정보 {'>'}</p>
                <p className='header'>{routeList[route]}</p>
            </div>
            
            <Tab 
                headerStyle={{ marginLeft : 20 }}
                routes={tabRoute}
                current={route.replace('/customer/','')}
                onTabChange={(name) => {setName(name);navigate(`/customer/${name}`)}}
                renderItems={{
                    'customer-list' : <Outlet/>,
                    'customer-memo' : <Outlet/>,
                }}
            />
        </div>
    )
}

export default Customer;